import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=3885f754&scoped=true&"
var script = {}
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=3885f754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885f754",
  null
  
)

export default component.exports